import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { debounce } from '../../../../../helpers/common'
import useDidUpdateEffect from '../../../../hooks/useDidUpdateEffect'
import { Checkbox } from '../../../../html/checkbox'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { InputDropdown } from '../../../../html/input/InputDropdown'
import { Loading } from '../../../../loading'
import { ScrollComponent } from '../../../../scrollComponent'
import { SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  changeListSelected,
  changeTextSearch,
  changeTypeCheckPort,
  handleCheckAllPort,
  loadingPortfolio,
  selectDataPortfolioAll,
  selectDataSearchPortfolio,
  selectIsAllCheck,
  selectListSelected,
  selectTextSearch,
} from '../../../store/slicePortfolio'
import { getSearchPortfolioInSetting } from '../../../store/thunk'

export const InputSearchPortfolio = () => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataSearchPortfolio)
  const listIdsSelected = useSelector(selectListSelected)
  const textSearch = useSelector(selectTextSearch)
  const isAll = useSelector(selectIsAllCheck)
  const dataAll = useSelector(selectDataPortfolioAll)
  const loading = useSelector(loadingPortfolio('searchPort'))

  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [inputValue, setInputValue] = useState(textSearch)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchPortfolioInSetting({
          InputSearch: value,
          Page: 1,
          PageSize: 300,
        }),
      )
    }, 700),
    [],
  )

  const clearText = () => {
    dispatch(changeTextSearch(''))
    setInputValue('')
  }

  const handleChoose = (item) => {
    dispatch(
      changeListSelected({
        value: item.portfolioId,
        label: item.portfolioName,
      }),
    )
  }

  const handleOpenDropdown = () => {
    setIsShowDropdown(true)
    !data.length && handleChangeText(textSearch)
  }

  const handleHideDropdown = () => {
    setIsShowDropdown(false)
    clearText()
    if (listIdsSelected.length === 0 && dataAll.length) {
      dispatch(handleCheckAllPort())
    }
  }

  const handleChooseAll = () => {
    dispatch(handleCheckAllPort())
  }

  const renderDropdown = () => {
    if (loading) {
      return <Loading style={{ backgroundColor: '#FFFFFF' }} />
    }

    if (!data || !data.length) {
      return (
        <div className="fstItalic">
          <Translate value="library.main.NODATA_SEARCH_COMPANY" />
        </div>
      )
    }

    return (
      <ScrollComponent autoHeight autoHeightMax={400}>
        <Element
          style={{
            borderBottom: '1px solid #D5D5D5',
          }}
          onClick={handleChooseAll}
          className="cursorPointer"
        >
          <Checkbox
            title="common.ALL"
            isI18n
            checked={isAll}
            isCheckOnClickText
            styleIcon={{ fontSize: 15, paddingRight: 8 }}
            style={{
              padding: '6px 0',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            onChange={handleChooseAll}
          />
        </Element>
        {data.map((item) => (
          <DropdownItem
            key={item?.portfolioId}
            item={item}
            handleChoose={handleChoose}
            listIdsSelected={listIdsSelected}
          />
        ))}
      </ScrollComponent>
    )
  }

  useDidUpdateEffect(() => {
    handleChangeText(inputValue)
  }, [inputValue])

  useEffect(() => {
    if (listIdsSelected.length < dataAll.length && isAll) {
      dispatch(changeTypeCheckPort(false))
    }
    if (listIdsSelected.length === dataAll.length) {
      dispatch(changeTypeCheckPort(true))
    }
  }, [listIdsSelected.length])

  return (
    <>
      <InputDropdown
        placeHolder="library.savePortfolio.savePortfolio"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        isShowDropdown={isShowDropdown}
        setIsShowDropdown={setIsShowDropdown}
        onClickOutsideDropdown={handleHideDropdown}
        onClick={handleOpenDropdown}
        inputProps={{
          style: { fontSize: 12 },
          noControl: true,
          isShowIcon: false,
          customElement: (
            <Icon
              className="icon-caret-bottom pointerEventsNone"
              style={{
                fontSize: 8,
                left: 'unset',
                right: 4,
              }}
            />
          ),
        }}
        dropdownContainerStyle={{
          minWidth: loading || !data || !data.length ? 'unset' : 400,
          minHeight: 50,
        }}
        scrollId={SCROLL_COMPONENT_IDS}
      >
        {renderDropdown()}
      </InputDropdown>
    </>
  )
}

export const DropdownItem = ({ item, handleChoose, listIdsSelected }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      onClick={() => {
        handleChoose(item)
      }}
      className="cursorPointer"
    >
      <Element style={{ borderBottom: '1px solid #D5D5D5' }}>
        <Checkbox
          title={item.portfolioName}
          checked={listIdsSelected
            .map((item) => item.value)
            .includes(item.portfolioId)}
          isCheckOnClickText
          styleIcon={{ fontSize: 15, paddingRight: 8 }}
          style={{ padding: '6px 0' }}
          onChange={() => handleChoose(item)}
        />
      </Element>
    </Element>
  )
}
